import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {AnalyticsService} from '../common/analytics.service';
import {Store} from "@ngrx/store";
import {AppState} from "../state/AppState";

@Component({
  selector: 'feature-dialog',
  templateUrl: 'feature.component.html'
})
export class FeatureDialogComponent {
  _feature = '';
  isSent = false;

  constructor(
    private dialogRef: MatDialogRef<FeatureDialogComponent>,
    private store: Store<AppState>,
    private analytics: AnalyticsService) {
    this.analytics.action('showFeatureRequest');
  }

  set feature(msg: string) {
    this.isSent = false;
    this._feature = msg;
  }

  get feature() {
    return this._feature;
  }

  submit(event: Event): void {
    this.isSent = true;
    event.preventDefault(); // no reload
    this.analytics.action('sendFeatureRequest', {msg: this._feature});
  }

  close(): void {
    this.dialogRef.close();
  }
}
